module.exports = __webpack_public_path__ + "img/公版.bdd5fe10.svg";